// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TutorialContainer {
    display: grid;
    grid-auto-flow: row;
    grid-row-gap: 10px;
    animation: fadeInGlobal 2s;
}

.tutorialStatusTextOnline {
    color: var(--HighlightBlue);
}

.tutorialStatusUrl {
    cursor: pointer;
    margin-top: 0px;
    color: var(--Gray);
    font-size: 11px;
}

.tutorialStatusTextOffline {
    color: rgb(196, 56, 56);
}

.tutorialContentContainerSetup {
    display: flex;
    flex-wrap: wrap;
    gap: 2em;
    justify-content: center;
}

.tutorialTestMemeContainerTest {
    display: inline-block;
    padding: 2em;
    max-width: 400px;
    width: 400px;
    height: 430px;
    border-radius: 10px;
    animation: moveLeftGlobal 1s;
    background-color: var(--DarkBlue);
}

.tutorialContainerContentSide {
    display: flex;
    flex-direction: column;
    gap: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Home/HomeContent/Tutorial/tutorial.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ","sourcesContent":[".TutorialContainer {\n    display: grid;\n    grid-auto-flow: row;\n    grid-row-gap: 10px;\n    animation: fadeInGlobal 2s;\n}\n\n.tutorialStatusTextOnline {\n    color: var(--HighlightBlue);\n}\n\n.tutorialStatusUrl {\n    cursor: pointer;\n    margin-top: 0px;\n    color: var(--Gray);\n    font-size: 11px;\n}\n\n.tutorialStatusTextOffline {\n    color: rgb(196, 56, 56);\n}\n\n.tutorialContentContainerSetup {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2em;\n    justify-content: center;\n}\n\n.tutorialTestMemeContainerTest {\n    display: inline-block;\n    padding: 2em;\n    max-width: 400px;\n    width: 400px;\n    height: 430px;\n    border-radius: 10px;\n    animation: moveLeftGlobal 1s;\n    background-color: var(--DarkBlue);\n}\n\n.tutorialContainerContentSide {\n    display: flex;\n    flex-direction: column;\n    gap: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
